import { Text } from "@mantine/core";
import { SectionTitleComponentProps } from "./types";

export function SectionTitleComponent(props: SectionTitleComponentProps) {
  const { children } = props;

  return <Text weight={600}>{children}</Text>;
}
